import { STATUS, ROLE_LABELS, fmtStamp } from "@/lib/format";

export default function StatusTimeline({ trip }) {
  const history = trip.status_history?.length
    ? trip.status_history
    : [{ status: "new", at: trip.created_at, by_name: trip.created_by_name, note: "Request created" }];
  const entries = [...history].reverse();
  const currentIdx = entries.findIndex((h) => h.status !== "acknowledged");
  return (
    <div className="lux-card p-5 sm:p-6" data-testid="status-timeline">
      <p className="eyebrow mb-5">Status timeline</p>
      <ol className="relative">
        {entries.map((h, i) => {
          const s = h.status === "acknowledged" ? { label: "Request Acknowledged" } : STATUS[h.status] || STATUS.new;
          const current = i === currentIdx;
          return (
            <li key={`${h.at}-${i}`} className="relative pl-7 pb-5 last:pb-0" data-testid={`status-timeline-entry-${i}`}>
              {i < entries.length - 1 && <span className="absolute left-[5px] top-3 bottom-0 w-px bg-white/10" />}
              <span className={`absolute left-0 top-1.5 h-[11px] w-[11px] rounded-full border ${current ? "bg-[#5B7FD1] border-[#5B7FD1]" : "bg-[#111319] border-white/25"}`} />
              <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
                <span className={`text-sm ${current ? "text-white" : "text-zinc-300"}`}>{s.label}</span>
                <span className="font-mono-data text-[11px] text-zinc-500">{fmtStamp(h.at)}</span>
              </div>
              <p className="text-[11px] text-zinc-500 mt-0.5">
                {h.by_name || "System"}{h.by_role ? ` · ${ROLE_LABELS[h.by_role] || h.by_role}` : ""}{h.note ? ` · ${h.note}` : ""}
              </p>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
